import { z } from "zod";

export const GlobalResponseSchema = z.object({
	message: z.string(),
});

export const GlobalPaginationResponse = z.object({
	count: z.number(),
	next: z.string().nullable(),
});
